<template>
  <div>
    <v-dialog
      v-model="this.$store.state.spinning"
      width="60%"
      height="60%">
      <v-container
        fluid
        fill-height
        style="background-color: rgba(255, 255, 255, 0.5);">
        <v-layout
          justify-center
          align-center>
          <v-progress-circular
            :color="color"
            size="100"
            indeterminate/>
        </v-layout>
      </v-container>
    </v-dialog>
    <transition mode="out-in">
      <router-view/>
    </transition>
  </div>
</template>

<style lang="scss">
  @import "@/styles/index.scss";

  /* Remove in 1.2 */
  .v-datatable thead th.column.sortable i {
      vertical-align: unset;
  }
</style>

<script>
  import { mapState } from 'vuex'
  import axios from 'axios'
  // checks to see if auth jwt token is valid or has expired, if it gets back 401 error log out
  export default {
    computed: {
      ...mapState('app', ['color'])
    },
    created: function () {
      // this.$store.state.spinning = false;
      axios.interceptors.response.use((response) => {
        return response
      }, (error) => {
        if (error.response.status === 403) {
          this.$store.dispatch('logout').then(() => {
            this.$router.push('/')
          })
        } else {
          return Promise.reject(error)
        }
      })
    }
  }
</script>
